import MathEx from "./MathEx";
export default class Vector3Ex {
    static get temp() {
        Vector3Ex.__temp__.setValue(0, 0, 0);
        return Vector3Ex.__temp__;
    }
    static get s_up() {
        Vector3Ex.__up__.setValue(0, 1, 0);
        return Vector3Ex.__up__;
    }
    static get s_down() {
        Vector3Ex.__down__.setValue(0, -1, 0);
        return Vector3Ex.__down__;
    }
    static get s_forward() {
        Vector3Ex.__forward__.setValue(0, 0, 1);
        return Vector3Ex.__forward__;
    }
    static get s_back() {
        Vector3Ex.__back__.setValue(0, 0, -1);
        return Vector3Ex.__back__;
    }
    static get s_zero() {
        Vector3Ex.__zero__.setValue(0, 0, 0);
        return Vector3Ex.__zero__;
    }
    static get s_one() {
        Vector3Ex.__one__.setValue(1, 1, 1);
        return Vector3Ex.__one__;
    }
    static get up() {
        return new Laya.Vector3(0, 1, 0);
    }
    static get down() {
        return new Laya.Vector3(0, -1, 0);
    }
    static get forward() {
        return new Laya.Vector3(0, 0, 1);
    }
    static get zero() {
        return new Laya.Vector3(0, 0, 0);
    }
    static get one() {
        return new Laya.Vector3(1, 1, 1);
    }
    static get back() {
        return new Laya.Vector3(0, 0, -1);
    }
    static get left() {
        return new Laya.Vector3(-1, 0, 0);
    }
    static get right() {
        return new Laya.Vector3(1, 0, 0);
    }
    static IsZero(vec) {
        return vec.x && vec.y == 0 && vec.z == 0;
    }
    static Cross(right, left) {
        var result = new Laya.Vector3(0, 0, 0);
        Laya.Vector3.cross(right, left, result);
        return result;
    }
    static Subtract(right, left) {
        var result = new Laya.Vector3(0, 0, 0);
        Laya.Vector3.subtract(right, left, result);
        return result;
    }
    static SubtractTo(right, left, to) {
        Laya.Vector3.subtract(right, left, to);
    }
    static ClampMagnitude(vector, maxLength) {
        var result = new Laya.Vector3(0, 0, 0);
        var sqrMagnitude = 0;
        if (Laya.Vector3.distanceSquared(vector, result) > maxLength * maxLength) {
            result = Vector3Ex.Scale(Vector3Ex.Normalize(vector), maxLength);
        }
        else {
            result = vector;
        }
        return result;
    }
    static Normalize(vec) {
        var result = new Laya.Vector3(0, 0, 0);
        Laya.Vector3.normalize(vec, result);
        return result;
    }
    static Add(...vecs) {
        var result = new Laya.Vector3(0, 0, 0);
        for (var i = 0; i < vecs.length; ++i) {
            var vec = vecs[i];
            result.x += vec.x;
            result.y += vec.y;
            result.z += vec.z;
        }
        return result;
    }
    static Scale(vec, scale) {
        var result = new Laya.Vector3(0, 0, 0);
        Laya.Vector3.scale(vec, scale, result);
        return result;
    }
    static ScaleV3(vec, scale) {
        var result = new Laya.Vector3(vec.x * scale.x, vec.y * scale.y, vec.z * scale.z);
        return result;
    }
    static Dot(left, right) {
        return Laya.Vector3.dot(left, right);
    }
    static Lerp(from, to, v) {
        var result = new Laya.Vector3(0, 0, 0);
        Laya.Vector3.lerp(from, to, v, result);
        return result;
    }
    static Bessel(p0, p1, p2, progress) {
        let cache1 = Vector3Ex.Scale(p0, Math.pow(1 - progress, 2));
        let cache2 = Vector3Ex.Scale(p1, 2 * progress * (1 - progress));
        let cache3 = Vector3Ex.Scale(p2, progress * progress);
        return Vector3Ex.Add(cache1, cache2, cache3);
    }
    static MagnitudeSqrt(v3) {
        return v3.x * v3.x + v3.y * v3.y + v3.z * v3.z;
    }
    static Magnitude(v3) {
        return Math.sqrt(this.MagnitudeSqrt(v3));
    }
    static Magnitude2D(v3) {
        return Math.sqrt(v3.x * v3.x + v3.z * v3.z);
    }
    static Distance(from, to) {
        var offset = Vector3Ex.Subtract(from, to);
        return Vector3Ex.Magnitude(offset);
    }
    static Distance2D(from, to) {
        let xOffset = from.x - to.x;
        let zOffset = from.z - to.z;
        return Math.sqrt(xOffset * xOffset + zOffset * zOffset);
    }
    static DistanceSqrt(from, to) {
        let offset = Vector3Ex.Subtract(from, to);
        return offset.x * offset.x + offset.y * offset.y + offset.z * offset.z;
    }
    static DistanceSqrt2D(from, to) {
        let offset = Vector3Ex.Subtract(from, to);
        return offset.x * offset.x + offset.z * offset.z;
    }
    /**
     * 计算在指定轴上的旋转,带符号
     * @param from
     * @param to
     * @param asix
     */
    static SignAngleAsix(from, to, asix) {
        let normalAsix = Vector3Ex.Normalize(asix);
        let dotFrom = Vector3Ex.Dot(from, normalAsix);
        let wrapFrom = Vector3Ex.Subtract(from, Vector3Ex.Scale(normalAsix, dotFrom));
        let dotTo = Vector3Ex.Dot(to, normalAsix);
        let wrapTo = Vector3Ex.Subtract(to, Vector3Ex.Scale(normalAsix, dotTo));
        let normalized = Vector3Ex.Normalize(wrapFrom);
        let normalized2 = Vector3Ex.Normalize(wrapTo);
        let num = Math.acos(MathEx.Clamp(Laya.Vector3.dot(normalized, normalized2), -1, 1)) * 57.29578;
        let cross = Vector3Ex.Cross(normalized, normalized2);
        let num2 = MathEx.Sign(Laya.Vector3.dot(asix, cross));
        return num * num2;
    }
    static SignedAngle(from, to, asix) {
        var normalized = Vector3Ex.Normalize(from);
        var normalized2 = Vector3Ex.Normalize(to);
        var num = Math.acos(MathEx.Clamp(Laya.Vector3.dot(normalized, normalized2), -1, 1)) * 57.29578;
        var cross = Vector3Ex.Cross(normalized, normalized2);
        var num2 = MathEx.Sign(Laya.Vector3.dot(asix, cross));
        return num * num2;
    }
    static Angle(from, to, asix) {
        var normalized = Vector3Ex.Normalize(from);
        var normalized2 = Vector3Ex.Normalize(to);
        var num = Math.acos(MathEx.Clamp(Laya.Vector3.dot(normalized, normalized2), -1, 1)) * 57.29578;
        return num;
    }
    static SmoothDamp(current, target, currentVelocity, smoothTime, maxSpeed, deltaTime) {
        var num = 2 / smoothTime;
        var num2 = num * deltaTime;
        var d = 1 / (1 + num2 + 0.48 * num2 * num2 + 0.235 * num2 * num2 * num2);
        var vector = Vector3Ex.Subtract(current, target);
        var vector2 = target.clone();
        var maxLength = maxSpeed * smoothTime;
        vector = Vector3Ex.ClampMagnitude(vector, maxLength);
        var target2 = Vector3Ex.Subtract(current, vector);
        var vector3 = Vector3Ex.Scale(Vector3Ex.Add(currentVelocity, Vector3Ex.Scale(vector, num)), deltaTime);
        var cacheV = Vector3Ex.Scale(Vector3Ex.Subtract(currentVelocity, Vector3Ex.Scale(vector3, num)), d);
        currentVelocity.x = cacheV.x;
        currentVelocity.y = cacheV.y;
        currentVelocity.z = cacheV.z;
        var vector4 = Vector3Ex.Add(target2, Vector3Ex.Scale(Vector3Ex.Add(vector, vector3), d));
        if (Vector3Ex.Dot(Vector3Ex.Subtract(vector2, current), Vector3Ex.Subtract(vector4, vector2)) > 0) {
            vector4 = vector2;
            currentVelocity.x = 0;
            currentVelocity.y = 0;
            currentVelocity.z = 0;
        }
        return vector4;
    }
    static Fix(vec, limit) {
        if (Math.abs(vec.x) < limit) {
            vec.x = 0;
        }
        if (Math.abs(vec.y) < limit) {
            vec.y = 0;
        }
        if (Math.abs(vec.z) < limit) {
            vec.z = 0;
        }
    }
    static IsSame(v1, v2) {
        return v1.x == v2.x && v1.y == v2.y && v1.z == v2.z;
    }
    static WrapFromUnity(x, y, z) {
        return new Laya.Vector3(-x, y, z);
    }
    /**
     * 计算带加速度的移动位置
     * @param time
     * @param startVelocity
     * @param aSpeed
     * @param startPos
     */
    static CalcPosWithASpeed(time, startVelocity, aSpeed, startPos) {
        let xt = Vector3Ex.Scale(startVelocity, time);
        let at2 = Vector3Ex.Scale(aSpeed, time * time / 2);
        return Vector3Ex.Add(xt, at2, startPos);
    }
    /**
     * 重置空间信息
     * @param trs
     */
    static InitialTransform(trs) {
        trs.localPosition = Vector3Ex.s_zero;
        trs.localScale = Vector3Ex.s_one;
        trs.rotationEuler = Vector3Ex.s_zero;
    }
    /**
     * 判定目标点，是否在以中心点为扇心，指定扇形内
     * @param center 扇形中心点
     * @param target 目标点
     * @param range 扇形半径
     * @param halfAngle 扇形半角
     * @param forward 扇形正向
     * @param axis 垂直于扇面的轴向
     */
    static InSector(center, target, range, halfAngle, forward, axis) {
        let dir = Vector3Ex.temp;
        dir.setValue((target.x - center.x) * (1 - axis.x), (target.y - center.y) * (1 - axis.y), (target.z - center.z) * (1 - axis.z));
        if (Vector3Ex.MagnitudeSqrt(dir) <= range * range) {
            let angle = Vector3Ex.Angle(forward, dir, axis);
            if (angle <= halfAngle) {
                return true;
            }
        }
        return false;
    }
}
/**
 *
 * 增加方向常量，可用于赋值给transform信息，
 * 只能用于当作临时变量使用，不可持有
 *
 */
Vector3Ex.__temp__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.__up__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.__down__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.__forward__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.__back__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.__zero__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.__one__ = new Laya.Vector3(0, 0, 0);
Vector3Ex.cacheVec0 = new Laya.Vector3(0, 0, 0);
